<template>
  <transition name="showPopup">
    <View v-if="isReady" />
  </transition>
  <div @click="$store.commit('opdracht/close')" class="fader" :class="{ visible: isReady && !$store.state.opdracht.minimized }"></div>
</template>

<script>
import View from "./View"

export default {
  components: { View },
  created() {
    this.bootstrap()
  },
  computed: {
    isReady() {
      return this.$store.state.opdracht.id
    }
  },
  methods: {
    bootstrap() {
      setTimeout(() => {
        // do something here...
      }, 1000)
    }
  }
}
</script>

<style lang="sass" scoped>
.showPopup-enter-active, .showPopup-leave-active
  transition: .5s
.showPopup-enter-from, .showPopup-leave-to
  transform: translateY(100%)

.fader
  position: fixed
  inset: 0
  transition: .2s
  z-index: 5
  background-color: rgba(0, 0, 0, 0.5)
  opacity: 0
  pointer-events: none
  &.visible
    pointer-events: auto
    opacity: 1
</style>
